/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import axios from 'axios'
import Reason from './reason'
import Info from './info'
import Loading from '../../components/loading'
import { CUSTOMER_FUEL_REQUEST_RECEIPT, REASON_SATISFACTION_LIST } from '../../constants/api'
import { NOT_FOUND_CODE } from '../../constants/router'
import SaveRating from './save_rating'

function RatingPage(props) {
    const history = useHistory()
    const [isRating, setIsRating] = useState(0)
    const [state, setState] = useState(0)
    const [score, setScore] = useState(0)
    const [ratingTab, setRatingTab] = useState(0)
    const [comment, setComment] = useState('')
    const [isComment, setIsComment] = useState(false)
    const [loading, setLoading] = useState(true)
    const [reasonRating, setReasonRating] = useState([])
    const [satisfaction, setSatisfaction] = useState({
        strengths: [],
        weakPoints: []
    })
    const [receipt, setReceipt] = useState({
        vRequestCode: '',
        vOperatorName: '',
        vFuelInfoTitle: '',
        jalaliDateTime: '',
        iVolumeReceived: '',
    })
    let { token } = useParams()
    token = token.replace('token=', '')

    useEffect(() => {
        calcData()
    }, [])

    const calcData = async () => {
        await getReceiptData()
        await getReasonSatisfaction()
        setLoading(false)
    }

    const getReasonSatisfaction = async () => {
        try {
            let url = process.env.REACT_APP_API_URL + REASON_SATISFACTION_LIST
            let response = await axios.post(url)
            let data = response.data
            if (data.settings.success === 1) {
                let strengths = []
                let weakPoints = []
                data.data.map((obj) => {
                    let temp = { vReasonSatisfactionTitle: obj.vReasonSatisfactionTitle }
                    obj.iType === 1 ? strengths.push(temp) : weakPoints.push(temp)
                })
                setSatisfaction({
                    strengths,
                    weakPoints
                })
            }
        } catch (error) {
        }
    }

    const getReceiptData = async () => {
        try {
            let url = process.env.REACT_APP_API_URL + CUSTOMER_FUEL_REQUEST_RECEIPT
            let response = await axios.post(url, { vToken: token })
            let data = response.data
            if (data.settings.success === 1) {
                setReceipt(data.data[0])
                setIsRating(data.data[0].isSurvey)
            } else {
                history.push(NOT_FOUND_CODE)
            }
        } catch (error) {
            history.push(NOT_FOUND_CODE)
        }
    }

    const setReasonRatings = (data) => {
        let checkData = reasonRating.indexOf(data)
        if (checkData === -1) {
            reasonRating.push(data)
        } else reasonRating.splice(checkData, 1)
        return reasonRating
    }


    return (
        <React.Fragment>
            {loading ? <Loading loadingPage={loading} /> :
                isRating === 1 ? <SaveRating /> :
                    state === 0 ?
                        <Info
                            receipt={receipt}
                            state={state}
                            score={score}
                            ratingTab={ratingTab}
                            setState={(value) => setState(value)}
                            setScore={(value) => setScore(value)}
                            setRatingTab={(value) => setRatingTab(value)}
                        /> :
                        <Reason
                            receipt={receipt}
                            reasonRating={reasonRating}
                            satisfaction={satisfaction}
                            state={state}
                            score={score}
                            ratingTab={ratingTab}
                            comment={comment}
                            isComment={isComment}
                            setState={(value) => setState(value)}
                            setReasonRating={(value) => setReasonRating(setReasonRatings(value))}
                            setScore={(value) => setScore(value)}
                            setComment={(value) => setComment(value)}
                            setIsComment={(value) => setIsComment(value)}
                            setRatingTab={(value) => setRatingTab(value)}
                            setIsRating={(value) => setIsRating(value)}
                        />}
        </React.Fragment>
    )
}

export default RatingPage

